import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { config } from 'config';
import { AppointmentSchema } from 'models/appointment.model';
import getHeaders from 'utils/getHeaders';
import { z } from 'zod';

export const BASE_URL = config.services.mediquo.chat_url;

export const GetAppointmentRequestSchema = z.object({
  appointmentId: z.string(),
});
export type GetAppointmentRequest = z.infer<typeof GetAppointmentRequestSchema>;

export const GetAppointmentResponseSchema = AppointmentSchema;
export type GetAppointmentResponse = z.infer<
  typeof GetAppointmentResponseSchema
>;

export const appointmentsApi = createApi({
  reducerPath: 'appointmentsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      Object.entries(getHeaders()).forEach(([key, value]) =>
        headers.set(key, value!)
      );
      return headers;
    },
  }),

  tagTypes: ['Appointment'],

  endpoints: (builder) => ({
    getAppointment: builder.query<
      GetAppointmentResponse,
      GetAppointmentRequest
    >({
      query: ({ appointmentId }) =>
        `/professionals/v1/appointments/${appointmentId}`,
      transformResponse: (response: { data: GetAppointmentResponse }) => {
        return response.data;
      },
      providesTags: (_result, _error, { appointmentId }) => [
        { type: 'Appointment', id: appointmentId },
      ],
    }),
  }),
});

export const { useGetAppointmentQuery } = appointmentsApi;
